module.exports = __webpack_public_path__ + "static/media/ab4679ed.jpg";